import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import {GlobalVariable} from '../../../../app/config';
import {GlobalDataService} from '../services/global-data.service';
import {User, ForgotPassword, ResetPasswordObj} from '../models/data-model';
import {EmitterService} from '../services/emitter.service';
@Component({
  selector: 'app-reset-password',
  templateUrl: '../views/reset-password.component.html',
  styleUrls: ['../css/reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
    public errorEmailVlaidCheckMsg ='';
    public ShowForm=true;
    public isEmailValid=false;
    public Emaildata = '';
    public errorMsg = '';
    public errorMessage = "";
    public submitted = false;
    public checkData=false;
    public isSuccess:boolean=false;
    public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;
    public reset_password: boolean = false;
    public new_password: boolean = false;
    public ucode='';
    public showpasswordvalid: boolean = false;
    public validatefirstpassword: boolean = false;
    public checklength: boolean = false;
    public checkcaptial: boolean = false;
    public checknumber: boolean = false;
    public user = new User('', '', new Date());
    public timezonelist: any;
    public fieldType=true;
    public resetpassword = new ResetPasswordObj('', '', {}, '', new Date(), '');
    public password_submitted: boolean = false;
    constructor(
        private _router: Router,
	private activeroute: ActivatedRoute,
        private _dataService: GlobalDataService,
        private _emitterService: EmitterService
    ) { }

    ngOnInit() {

      const currentpath = this._router.url;
      const path = currentpath.split("/");
      this.ucode=path[2];
      const user_type = path[3];
      this.errorMessage="";
         if(this.ucode!='' && this.ucode != undefined && this.ucode!='undefined'){
            this._dataService.GetAjaxCall(this.apiendpoint_url + '/user/verify/uniqueCode?key='+this.ucode, (result) => {
                    if(result.statusCode==200){
                    this.resetpassword.passwordResetLink=this.ucode;
                    this.resetpassword.timezone.id=(result.response.timezone!=null)?result.response.timezone.id:''; 
                    this.reset_password=false;
                    this.new_password=true;
                    this. getTimezonelist();
                    this.errorMessage=""; 

                }else if(result.statusCode==401){
                   this.reset_password=true;
                   this.new_password=false; 
                   this.errorMessage="This link is expired. Please use recent link.";
                
                }else{
                   this.reset_password=true;
                   this.new_password=false; 
                   this.errorMessage="Invalid data";  
                } 
            });
            
         }else{
                this.reset_password=true;
                this.new_password=false; 
         }
             
        //this.Emaildata=localStorage.getItem('email')?localStorage.getItem('email'):'';
        this.Emaildata=sessionStorage.getItem('email')?sessionStorage.getItem('email'):'';
    }
    validateEmail(email){
      const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isEmailValid = pattern.test(email);
    }
    showForm(){
 	this.errorEmailVlaidCheckMsg='';
 	this.ShowForm = !this.ShowForm;
    }
    /*To  clear the error mesasge */
    unsetValidation(){
        this.checkData=false;
        this.errorEmailVlaidCheckMsg='';
    }
    resetPwd(){
        this.errorMessage="";
        this.unsetValidation();
        this._dataService.resetPwd(this.Emaildata, (result) =>
            {
              let userdata = '';
              if(result=='FORGOT_PASSWORD_SUCCESSFULLY'){
                    this.isSuccess=true;
                    userdata = result;
                    this.submitted =false;
                    this.checkData =false;
                    this.Emaildata ='';  //reset form
                    //this.ShowForm= false;
                    this.reset_password=true;
                    this.new_password=false;

                }else if(result=='INACTIVE_USER'){
                        this.isSuccess=false;
                        userdata = '';
                        this.checkData=true;
                        this.errorMsg = 'Your login has been disabled.';

                }else if(result=='BLOCK_ACCOUNT'){
                        this.isSuccess=false;
                        userdata = '';
                        this.checkData=true;
                        this.errorMsg = 'Your account has been locked. Please try again after 30 minutes.';
                }else if(result=='DELETE_USER'){
                        this.isSuccess=false;
                        userdata = '';
                        this.checkData=true;
                        this.errorMsg = 'No account found with that email address.';
                }else{
                        this.isSuccess=false;
                        userdata = '';
                        this.checkData=true;
                        this.errorMsg = 'The email you have entered does not exist.';

                }
            });  
    } 
    
 getTimezonelist() {
   
        this._dataService.GetAjaxCall(this.apiendpoint_url + '/user/timezone/list', (result) => {
            this.timezonelist = result;
        });
     
    } 
    
    savepassword() {
      const thisObj = this;
      this.resetpassword.lastlogintime = new Date();
        this.resetpassword.timeZoneId=this.resetpassword.timezone.id;
        this._dataService.PostAjaxCall(this.apiendpoint_url + "/user/resetPassword", this.resetpassword, (result) => {
                 if(result =='RESET_PASSWORD_SUCCESSFULLY'){
                this._emitterService.setloadHeader(false);
                thisObj.errorMessage = '';
                this._router.navigate(['login']);
            } else {
                    this.reset_password = false;
                    this.new_password = true;
                    thisObj.errorMessage = "Invalid details. Please udpate again !!"
            }
        }) 
    } 
    validatepassword() {
        this.showpasswordvalid = this.resetpassword.password != "";
        this.checkcaptial = false;
        this.checknumber = false;
        this.checklength = false;
        this.validatefirstpassword = false;
        if (this.resetpassword.password.match(/.*[A-Z].*/))
            this.checkcaptial = true;
        if (this.resetpassword.password.match(/.*\d.*/))
            this.checknumber = true;
        if (this.resetpassword.password.length >= 8)
            this.checklength = true;
        if (this.checklength && this.checknumber && this.checkcaptial)
            this.validatefirstpassword = true;
        /*if (!this.validatefirstpassword && this.password_submitted)
            this.errorMessage = "Your new password will need minimum 8 length characters,atleast 1 capital character,and 1 digit " */

    }
}




// WEBPACK FOOTER //
// ./src/app/modules/housekeeping/components/reset-password.component.ts